import { useState } from 'react';
import { profile } from '@/data';
import { asset } from '@/lib/paths';

/**
 * The About portrait, with an automatic fallback to the placeholder.
 *
 * It tries `public/headshot.jpg` first and drops back to the placeholder SVG if
 * that file is missing. That means replacing the photo is a pure file drop —
 * save a portrait as public/headshot.jpg, commit, push, done. No code edit, so
 * there is no second step to forget and no way to end up with a real photo
 * still captioned "Placeholder image".
 *
 * The cost is one 404 for the missing headshot until a real one is added.
 * That is a single small request, and it disappears the moment the file exists.
 */
const REAL_PHOTO = 'headshot.jpg';

export function Portrait() {
  const [usingPlaceholder, setUsingPlaceholder] = useState(false);

  return (
    <figure className="group w-40 sm:w-44">
      <div className="overflow-hidden rounded-2xl border border-border">
        <img
          src={asset(usingPlaceholder ? profile.photo : REAL_PHOTO)}
          onError={() => setUsingPlaceholder(true)}
          alt={
            usingPlaceholder
              ? 'Placeholder portrait — photo not yet supplied'
              : `Portrait of ${profile.name}`
          }
          width={400}
          height={400}
          decoding="async"
          className="aspect-square w-full object-cover transition-transform duration-500 ease-out group-hover:scale-105 motion-reduce:transition-none motion-reduce:group-hover:scale-100"
        />
      </div>
      {usingPlaceholder ? (
        <figcaption className="mt-2 text-center text-xs text-muted-foreground">
          Placeholder image
        </figcaption>
      ) : null}
    </figure>
  );
}
